import {NavLink} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import css from './layout.module.css';
import {Icon, type IconName} from '../common/Icon';
import {Menu, MenuItem} from '../common/ui';
import {useCreate} from '../../context/CreateProvider';
import {useAuth} from '../../context/AuthProvider';
import {useUpgrade} from '../../context/UpgradeProvider';
import owlIcon from '../../assets/owl.png';
import premiumClaw from '../../assets/premium_claw.png';

const NAV: Array<{to: string; icon: IconName; labelKey: string}> = [
  {to: '/notes', icon: 'notes', labelKey: 'Notes'},
  {to: '/ask', icon: 'sparkles', labelKey: 'AskAI'},
  {to: '/settings', icon: 'settings', labelKey: 'Settings'},
];

export function Sidebar() {
  const {t} = useTranslation();
  const {openRecord, openImport, openYoutube} = useCreate();
  const {entitlement} = useAuth();
  const {showUpgrade} = useUpgrade();

  return (
    <nav className={`${css.sidebar} no-print`}>
      <div className={css.logo}>
        <img src={owlIcon} alt="" />
        Owlly
      </div>

      <Menu
        trigger={
          <button className={css.newNoteBtn} style={{width: '100%'}}>
            <Icon name="plus" size={18} />
            {t('New Note').replace('✍️ ', '')}
          </button>
        }
      >
        {close => (
          <>
            <MenuItem
              icon="mic"
              onClick={() => {
                close();
                openRecord();
              }}
            >
              {t('Record Audio')}
            </MenuItem>
            <MenuItem
              icon="upload"
              onClick={() => {
                close();
                openImport();
              }}
            >
              {t('ImportAudioFile')}
            </MenuItem>
            <MenuItem
              icon="file"
              onClick={() => {
                close();
                openImport();
              }}
            >
              {t('ImportPDF')}
            </MenuItem>
            <MenuItem
              icon="youtube"
              onClick={() => {
                close();
                openYoutube();
              }}
            >
              {t('ImportYoutubeLink')}
            </MenuItem>
          </>
        )}
      </Menu>

      {NAV.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({isActive}) =>
            isActive ? css.navItemActive : css.navItem
          }
        >
          {({isActive}) => (
            <>
              <span className={css.navItemInner}>
                <Icon name={item.icon} size={19} />
                <span className={css.navLabel}>{t(item.labelKey)}</span>
              </span>
              {isActive && <span className={css.navIndicator} />}
            </>
          )}
        </NavLink>
      ))}

      <div className={css.sidebarSpacer} />

      {entitlement === 'pro' ? (
        <div className={css.proBadge} style={{cursor: 'default'}}>
          <span className={css.proBadgeIcon}>
            <Icon name="crown" size={16} />
          </span>
          <div>
            <div className={css.proBadgeTitle}>Owlly Pro</div>
          </div>
          <img className={css.proBadgeClaw} src={premiumClaw} alt="" />
        </div>
      ) : (
        <div className={css.proBadge} onClick={() => showUpgrade('generic')}>
          <span className={css.proBadgeIcon}>
            <Icon name="crown" size={16} />
          </span>
          <div style={{minWidth: 0}}>
            <div className={css.proBadgeTitle}>{t('upgrade_premium')}</div>
            <div>{t('SubscribeNow')}</div>
          </div>
          <img className={css.proBadgeClaw} src={premiumClaw} alt="" />
        </div>
      )}
    </nav>
  );
}
